import PropTypes from 'prop-types';
import { useUnsavedChangesNavigationGuard } from '../utils/useUnsavedChangesNavigationGuard';

const UnsavedChangesNavigationGuard = ({ active, message }) => {
  useUnsavedChangesNavigationGuard(active, message);

  return null;
};

UnsavedChangesNavigationGuard.propTypes = {
  active: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default UnsavedChangesNavigationGuard;
